export enum NewsfeedFilterType {
  Preset = 'preset',
  Promotion = 'promotion',
}

export interface NewsfeedFilterDto {
  filterFieldId?: NewsfeedFilterType;
  filterValues?: string[];
}
